import React, { Component } from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import { WikiMarkupTransformer } from '@atlaskit/editor-wikimarkup-transformer';
import { ReactRenderer, ADFEncoder } from '@atlaskit/renderer';

export default class ModalDialog extends Component {
    constructor (props, ...args) {
        super(props, ...args)
        let {display} = props
        this.state = {
          show: display ? display : false,          
        }
      }

    close = () => {
      let {handleClose} = this.props
      this.setState({ show: false })   
      handleClose()   
    }

    render () {
        let { children } = this.props               
        const actions = [
            { text: 'Close', onClick: this.close }      
        ]
        const adfEncoder = new ADFEncoder( () => new WikiMarkupTransformer())
        return (
            <div>
              <ModalTransition>
                {this.state.show && (
                  <Modal actions={actions} onClose={this.close} heading={children.HEADER ? children.HEADER : "Error"}>
                    <ReactRenderer document={adfEncoder.encode(children.MESSAGE ? children.MESSAGE : children)} />
                  </Modal>
                )}
              </ModalTransition>
            </div>
          )
    }
}



// WEBPACK FOOTER //
// ./client/src/components/ModalDialog.js